<template>
  <modal-template :name="modalName">
    <template slot="header">
      <h2 class="h1" v-t="'modal.members_only.title'"/>
    </template>
    <template slot="default">
      <p v-if="cart.membersOnlyErrorReason == 'error.cart.membership.rule.no-valid-membership'" v-t="'modal.members_only.no_valid_membership'" />
      <p v-if="cart.membersOnlyErrorReason == 'error.cart.membership.redeem.quota-reached'" v-t="'modal.members_only.quota_reached'" />
      <p v-if="cart.membersOnlyErrorReason == 'error.cart.membership.connection-issue'" v-t="'modal.members_only.connection_issue'" />
      <p>
        <a :href="membersInformationUrl" v-t="'modal.members_only.further_information'" target="_blank"/>
      </p>
    </template>
    <template slot="footer">
      <button class="btn--inverted" @click="selectNonMemberTickets">{{ $t('modal.members_only.select_non_member_tickets') }}</button>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate.vue";
import { mapState, mapActions } from 'vuex';

export default {
  name: "modal-members-only",
  components: {
    ModalTemplate,
  },
  data() {
    return {
      modalName: "modal-members-only",
    };
  },
  methods: {
    selectNonMemberTickets() {
      this.$modal.hide(this.modalName)
      this.clearMembersErrorMessage();
      this.updateMembersOnlyTicketSelected(false)
    },
    ...mapActions(['clearMembersErrorMessage', 'updateMembersOnlyTicketSelected'])
  },
  computed: {
    membersInformationUrl() {
      return process.env.VUE_APP_WK_FRONT_END_URL + "/" + this.$i18n.locale + "/mplus"
    },
    ...mapState(['cart'])
  }
};
</script>
